import { useState, useEffect } from "react";
import axios from "axios";
import "./resultupload.css";
import IsLoading from "../../../isLoading";
import ResultUploadDetail from "./student/ResultUploadDetail";

export default function ResultUpload() {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className=" result_upload">
          <ResultUploadDetail />
        </div>
      )}
    </>
  );
}
